export default function closeSidePanel() {
    document.getElementById("sidePanel").style.width = "0%";
}